import cx from 'classnames';

import { icons } from '~/ui/assets/_generated/icons';

import styles from './icon.module.scss';

export type IconName = keyof typeof icons;
type IconComponent = (typeof icons)[IconName];
type IconComponentProps = React.ComponentProps<IconComponent>;

export interface IconProps extends Omit<IconComponentProps, 'children'> {
  name: IconName;
}

export function Icon({ name, className, ...props }: IconProps) {
  const Component = icons[name];
  return (
    <Component
      {...props}
      className={cx(className, {
        [styles.expandingArrow]: [
          'expanding-arrow-left',
          'expanding-arrow-right',
          'expanding-arrow-diagonal',
        ].includes(name),
        [styles.expandingArrowLeft]: name === 'expanding-arrow-left',
        [styles.expandingArrowRight]: name === 'expanding-arrow-right',
        [styles.expandingArrowDiagonal]: name === 'expanding-arrow-diagonal',
      })}
    />
  );
}
